import React from "react";

export default function QuestionWindow({ sentence }: { sentence: string }) {
  return (
    <div>
      <div className="sample-box-01">
        {sentence}
        <br />
      </div>
    </div>
  );
}
